<template>
  <article class="user_view">
    <left-menu/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Clients' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Editar cliente</h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre</label>
            <input v-model="company.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>NIT</label>
            <input v-model="company.nit" type="number" placeholder="NIT"/>
          </div>
          <div class="form_input">
            <label>Departamento</label>
            <select id="select1" style="color: #A8B1BF;" @focus="selectFocused1()" @blur="selectBlur1()" @change="reviewDepto()" v-model="company.department">
              <option v-if="!company.department" value="" >Departamento</option>
              <!--option v-else :value= "company.department"></option-->
              <option v-for="(depto,index) in departaments" :key="index" :value= depto >{{depto}}</option> 
            </select>
          </div>
          <div class="form_input">
            <label>Ciudad</label>
            <select id="select" style="color: #A8B1BF;" @focus="selectFocused()" @blur="selectBlur()" v-model="company.city">
              <option v-if="!company.city" value="" disabled selected hidden>Ciudad</option>
              <!--option v-else :value= company.department selected> {{company.department}}</option-->
              <option v-for="(city, index) in ownCities[company.department].cities" :key="index" :value= city >{{city}}</option> 
            </select>
          </div>
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" :class="{'click':isCreated,'active': isComplete()}" @click.prevent="editClient" :style="{width: '160px', height:'46px'}">GUARDAR</button>
      </section>
    </section>
  </article>
</template>

<script>
import Departaments from './../../vue/additionalData/departaments.js';
import Cities from './../../vue/additionalData/cities.js';
export default {
  data(){
    return{
      isCreated:false,
      errorMessage:"",
      company: {
        name: '',
        nit: '',
        city: '',
        department:''
      },
      client:{},
      departaments:Departaments.departaments,
      ownCities: Cities.cities,
      
    }
  },
  methods:{
      editClient(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            edit: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}                   
        };
        this.resource= this.$resource('company/' + this.$route.params.id,{},customActions);
        this.resource.edit({
          company:{
            name: this.company.name,
            nit: this.company.nit,
            city: this.company.department+'-'+this.company.city,
          }
        })
        .then(function(data){
          this.$router.push({ name: 'Clients' });
        }).catch(function(err){
           var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de cedula ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
          }
        });
      },
      isComplete(){
        if(this.company.name!='' && this.company.nit!='' && this.company.city!='' && this.company.department!=''){
          return true;
        }
        
      },
      selectFocused(){
        document.getElementById("select").style="color: black;"
      },
      selectBlur(){
        if(!this.company.city){
          document.getElementById("select").style="color: #A8B1BF;"
        }
      },
      selectFocused1(){
        document.getElementById("select1").style="color: black;"
      },
      selectBlur1(){
        if(!this.company.department){
          document.getElementById("select1").style="color: #A8B1BF;"
        }
      },
      reviewDepto(){
        if(this.ownCities[this.company.department].cities.length<=1){
          this.company.city=this.ownCities[this.company.department].cities[0];
          document.getElementById("select").style="color: black; "
        }else{
          this.company.city="";
          document.getElementById("select").style="color: #A8B1BF; "
        }
      }
      
    },
    created(){

        const customActionsGet={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
        };
        this.$resource('company_devices/'+ this.$route.params.id,{},customActionsGet).get()
        .then(function(data){
          this.client=data.body;
          this.company.name = this.client.name;
          this.company.nit = this.client.nit;
          this.company.department = this.client.city.split('-')[0];
          this.company.city = this.client.city.split('-')[1];
          //console.log(data.body[0].user);
        });
        
    },
    mounted(){
      this.selectFocused();
      this.selectFocused1();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/EditClient.vue